import React, { useState } from 'react';

const ReadMore = ({ text, charLimit }) => {
  const [isReadMore, setIsReadMore] = useState(true);

  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };

  const renderText = isReadMore ? text.slice(0, charLimit) : text;

  return (
    <div>
      <p>
        {renderText}
        {text.length > charLimit && (
          <span onClick={toggleReadMore} style={{ color: 'blue', cursor: 'pointer' }}>
            {isReadMore ? '... Read More' : ' Show Less'}
          </span>
        )}
      </p>
    </div>
  );
};

export default ReadMore;
